import React from 'react'
import FormUser from '../../../../component/formUser/formUser'

export default function createUser() {
  return (
    <FormUser />
  )
}
